export default {
  title: 'Primește fluturași lunari automat',
  status: {
    enabled: 'Activat',
    disabled: 'Dezactivat',
  },
  opt_out: {
    on_hint: 'Planul tău Foodamigos include 500 de fluturași gratuiți pe lună. Dezactivează pentru a nu-i mai primi.',
    off_hint: 'Fluturașii automat sunt opriți. Activează pentru a relua din luna viitoare.',
    confirm_off: {
      title: 'Oprești fluturașii automat?',
      body: 'Dezactivând aceasta, {{location}} nu va mai primi fluturași automat începând cu luna viitoare. Comenzile existente nu sunt afectate.',
      confirm: 'Oprește',
      cancel: 'Menține activ',
    },
  },
  approved_design: {
    label: 'Design aprobat pentru fluturași lunari',
    auto_option: 'Automat (cel mai recent comandat)',
    flyer_slot: 'Fluturash {{slot}}',
    custom: 'Personalizat',
    untitled: 'Fără titlu',
    invalid_warning:
      'Designul salvat nu mai este disponibil. Se va folosi fluturașul comandat cel mai recent până când selectezi unul nou.',
  },
  toasts: {
    failed_to_load: 'Eroare la încărcarea setărilor fluturașilor automat',
    failed_to_save: 'Eroare la salvarea modificărilor',
    saved: 'Modificările au fost salvate',
  },
};
